import { useEffect } from "react";

interface UsePageSEOProps {
  title: string;
  description?: string;
  noIndex?: boolean;
}

export function usePageSEO({ title, description, noIndex }: UsePageSEOProps) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDesc = meta?.getAttribute("content") || "";
    if (description && meta) meta.setAttribute("content", description);

    let robotsMeta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const previousRobots = robotsMeta?.getAttribute("content") || "";
    if (noIndex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.name = "robots";
        robotsMeta.content = "noindex, nofollow";
        document.head.appendChild(robotsMeta);
      } else {
        robotsMeta.setAttribute("content", "noindex, nofollow");
      }
    }

    return () => {
      document.title = previousTitle;
      if (meta) meta.setAttribute("content", previousDesc);
      if (noIndex && robotsMeta) {
        if (previousRobots) {
          robotsMeta.setAttribute("content", previousRobots);
        } else {
          robotsMeta.remove();
        }
      }
    };
  }, [title, description, noIndex]);
}
